export function debugLog(message: string, ...args: any[]) {
  const debugMode = localStorage.getItem('dbmDebugMode') === 'true';
  if (debugMode) {
    console.log(`%cTAG: ${message}`, 'color: lightgreen;', ...args);
  }
}
